<template>
	<div class="contain_vip" :class="{'pb-30': padShow }">
		<div class="sw_contain" v-if="show">
			<swiper :options="swiperOption" ref="mySwiper" >
				<swiper-slide v-for="(item, index) in vip" :key="index" data-index = "index">
					<div class="pr">
						<img :src="item.img">
						<div class="inner_contain">
              				<div class="fz-22 l-h-20 mb-14 fw-600" >{{item.txt}}会员</div>
							<div class="fz-12">会员专属服务 加入即享多重特权</div>
						</div>
						<img class="img_po" src="../../assets/img/icon/vip.png" alt="">
					</div>
				</swiper-slide>
			</swiper>
		</div>

		<ul class="flexs flex-center" >
      		<li class="every_vip text-center pt-15 box-s" v-for="(item, index) in vipData" :key="index" :class="{ 'vip_active': activeIndex == index}" @click="getIndex(index, item)">
				<div class="fw-500 fz-15 l-h-15 c1">{{item.days}}</div>
				<div class="c6 fz-15 fw-500 mtb-17 ">￥<span class="fw-600 fz-26 l-h-21">{{item.price}}</span> </div>
				<div class="l-h-15 c2 fz-15">（{{item.numbers}}天）</div>
			</li>
		</ul>

		<div class="ptlr-16">
			<div class="flexs mb-10">
				<div class="title_line wh_3_15"></div>
				<div class="fw-500 fz-16 c1 ml-8">会员权限说明</div>
			</div>

			<div v-if="data.MembersExplain" v-html="data.MembersExplain"></div>
		</div>

		<div class="flexs flex-jus p-fixed_bottom bg_f box-shaw1 pd-15 box-s">
			<div class="flexs fz-15">
				<div class="c1">支付金额：</div>
				<div class="c6 fw-600">{{price}}元</div>
			</div>
			<div class="vip_btn" @click="submit">立即开通</div>
		</div>
		<loading :loadFlag="loadFlag"></loading>
	</div>
</template>

<script>
	import {getShowPadding} from "@/utils/common.js";
	import {userGrade, buyGrade} from "@/api/api.js";
	import loading from "@/components/loading"
	import wx from "weixin-js-sdk";
	export default {
		components: {
			loading
		},
		data() {
			return {
				swiperOption: {
					loop: true,
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					observeParents: true, //修改swiper的父元素时，自动初始化swiper 
					slidesPerView: "auto",
					centeredSlides: true,
					onTransitionEnd: swiper=>{
					},
					onSlideChangeEnd: swiper=>{
						const index = swiper.activeIndex
						this.activeIndex = 0
						//this.vipData = index == 3 || index == 6? this.data.gold:(index == 4? this.data.platinum:(index == 5|| index == 2? this.data.jewel: this.data.gold))
						if(this.top_professional_classification_id == 2){
							console.log('swiper-1',this.top_professional_classification_id)
							//单招-原来逻辑
							this.vipData = index == 3 || index == 6? this.data.gold:(index == 4? this.data.platinum:(index == 5|| index == 2? this.data.jewel: this.data.gold))
							console.log('swiper-1-vipData',this.vipData)
						}else if(this.top_professional_classification_id == 1 || this.top_professional_classification_id == 128){
							//专升本
							console.log('swiper-2',this.top_professional_classification_id)
							this.vipData = index == 3 || index == 6? this.data.gold_2:(index == 4? this.data.platinum_2:(index == 5|| index == 2? this.data.jewel_2: this.data.gold_2))
							console.log('swiper-2-vipData',this.vipData)
						}
						this.price = this.vipData?this.vipData[0].price:0
						this.gid = this.vipData?this.vipData[0].id:0
						console.log('vipData-last-',this.vipData)
						this.getChange(this.gid)
					},
					onInit: swiper =>{
						const type= this.$route.query.type
						const num = type == 0 || type == 1? 3: (type == 2?4:(type==3?2:6))
						swiper.slideTo(num)
					}
				},
				loadFlag: false,
				vip: [
					{
            			img: require("../../assets/img/bg/yellow_vip.png"),
						txt: '黄金'
					},
					{
            			img: require("../../assets/img/bg/blue_vip.png"),
						txt: '铂金'
					},
					{
            			img: require("../../assets/img/bg/purple_vip.png"),
						txt: '钻石'
					},
				],

				vipfee: [
					{
						time: '一个月',
						price: '19',
						timenum: '30'
					},
					{
						time: '半年',
						price: '58',
						timenum: '180'
					},
					{
						time: '一年',
						price: '218',
						timenum: '360'
					}
				],
				activeIndex: 0,
				txt: '<p>你好</p>',
        		padShow: false,
				data: {},
				vipData: [],
				price: 0,
				gid: '',
				show: false,
				payData:{},
				top_professional_classification_id:'',//专业（单招/专升本）
			}
		},
		created() {
      		this.initData()
		},
		mounted(){
			this.padShow = getShowPadding()
		},
		computed: {
			swiper() {
				return this.$refs.mySwiper.swiper;
			},
		},
		methods: {
			// 初始化
			async initData(){
				this.loadFlag = true
        		const res = await userGrade()
				this.loadFlag = false
				if(res.code == 1000){
          			this.data = res.data
					this.show = true
					const type= this.$route.query.type
					this.top_professional_classification_id = res.data.top_professional_classification_id
					//this.vipData = type == 0 || type == 1? this.data.gold: (type == 2?this.data.platinum:(type==3?this.data.jewel:this.data.gold))
					
					if(this.top_professional_classification_id == 2){
						console.log('a-',this.top_professional_classification_id)
						//单招-原来逻辑
						this.vipData = type == 0 || type == 1? this.data.gold: (type == 2?this.data.platinum:(type==3?this.data.jewel:this.data.gold))
					}else if(this.top_professional_classification_id == 1 || this.top_professional_classification_id == 128){
						console.log('b-',this.top_professional_classification_id)
						//专升本
						this.vipData = type == 0 || type == 4? this.data.gold_2: (type == 5?this.data.platinum_2:(type==6?this.data.jewel_2:this.data.gold_2))
					}
					
					this.price = this.vipData[0].price
					this.gid = this.vipData[0].id
					// this.getChange(this.gid)
				}else {
					 this.$toast(res.msg)
				}
				console.log('vipData最终-',this.vipData)
			},

			// 转换vip价格
			getIndex(index, item){
        		this.activeIndex = index
				this.price = item.price
				this.gid = item.id
				this.getChange(this.gid)
			},

		submit(){
			// let { appId, nonceStr, package, paySign, signType, timeStamp } = this.payData
      		wx.ready(() => {
				wx.chooseWXPay({
					appId:this.payData.appId, 
					timestamp: this.payData.timeStamp, 
					nonceStr:this.payData.nonceStr, 
					package: this.payData.package, 
					signType:this.payData.signType, 
					paySign:this.payData.paySign, 
					success: (res) => {
						console.log(res,'99')
						if (res.errMsg === "chooseWXPay:ok") {
              				this.$toast('支付成功')
							localStorage.setItem('indexFlag', 1)
							setTimeout(()=>{
                				this.$router.replace('/member')
							}, 1000)
						}
					},
					complete: (res) => {
						console.log(res,'9933')
						// 调用完成时的回调：成功或失败都会执行
						if (res.errMsg === "chooseWXPay:ok") {
							this.$toast.success('支付成功')
							localStorage.setItem('indexFlag', 1)
							localStorage.setItem('merFlag', 1)
							setTimeout(()=>{
                				this.$router.replace('/member')
							}, 1000)
							console.log("complete支付成功:", res);
						}
						else if (res.errMsg === "chooseWXPay:cancel") {
							console.log("complete取消支付:",res);
						} else if (res.errMsg === "chooseWXPay:fail") {
							this.$toast('支付失败')
							console.log("complete支付失败:",res);
						}
					},
					fail: (res) => {
						this.$toast('支付失败')
						console.log(res,'9955')
					},
					cancel: (res) => {
						console.log(res,'99000')
					},
				});
			})
			wx.error(function(res){
				console.log(res,999888)
			});
		},

		async	getChange(id) {
			const res = await buyGrade({ gid: id })
			if(res.code == 1000){
				const data = res.data
				this.payData = data
				wx.config({
					debug: false, // 开启调试模式
					appId: data.appId, // appId 必填，公众号的唯一标识
					timestamp: "" + data.timeStamp, // 必填，生成签名的时间戳
					nonceStr: data.nonceStr, // 必填，生成签名的随机串
					signature: data.paySign, // 必填，签名
					jsApiList: ["chooseWXPay"], // 必填，需要使用的JS接口列表
				});

			} else {
				this.$toast(res.msg)
			}
		}
		}
	}
</script>

<style scoped lang="less">
  .contain_vip {
		overflow-x: hidden;
	}
	.sw_contain {
		padding-top: 20px;
		margin: 0 45px 25px;
	}
	.swiper-container {
		width: 100%;
		height: 146px;
		overflow: visible !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide {
		width: 285px;
		border-radius: 6px;
		padding: 0 10px;
	}

	.swiper-container .swiper-wrapper .swiper-slide img {
	  width: 285px;
		height: 146px;
		border-radius: 6px;
	}

	.swiper-container .swiper-wrapper .swiper-slide-prev {
		margin-top: 8px;
		height: 130px !important;

	}

	.swiper-container .swiper-wrapper .swiper-slide-prev img {
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-next {
		margin-top: 8px;
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-next img {
		height: 130px !important;
	}

	.swiper-container .swiper-wrapper .swiper-slide-active {
		width: 285px;
		/* margin: 0 20px; */
	}

	.inner_contain {
		position: absolute;
		left: 24px;
		top: 26px;
		color: #fff;
	}

	.img_po {
		position: absolute;
		right: 24px;
		bottom: 15px;
		width: 33px !important;
		height: 31px !important;
	}

	.every_vip {
		width: 103px;
		height: 115px;
		background: #FFFFFF;
		border-radius: 6px;
		border: 1px solid #E0E0E0;
		margin-right: 13px;

		&:last-child{
			margin-right: 0;
		}
	}

	.vip_active {
		background: rgba(73, 124, 255, 0.05);
    border: 1px solid #497CFF;
	}

	.vip_btn {
		width: 157px;
		height: 50px;
		line-height: 50px;
		background: #497CFF;
		box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.06);
		border-radius: 6px;
		text-align: center;
		font-size: 15px;
		font-weight: 600;
		color: #FFFFFF;
	}

</style>